export default __webpack_public_path__ + "static/media/Rejected.cf8efe49.svg";